import { useState } from "react"
import { useTranslation } from "react-i18next"

import LogoPng from "@/assets/imgs/logo-1.png"

import { ANCHORS, DOWNLOAD_PAGE_URL } from "../site-config"
import { LangSelect } from "./LangSelect"
import { CONTAINER } from "./styles"

/** 官网顶部导航：桌面平铺 + 移动端折叠，CTA 统一导向下载页 */
export function SiteHeader() {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  const navItems = [
    { id: ANCHORS.model, label: t("official_nav_model") },
    // { id: ANCHORS.payment, label: t("official_nav_payment") },
    { id: ANCHORS.refund, label: t("official_nav_refund") },
    { id: ANCHORS.terms, label: t("official_nav_terms") },
    { id: ANCHORS.faq, label: t("official_nav_faq") },
    { id: ANCHORS.contact, label: t("official_nav_contact") },
  ]

  const linkClass =
    "text-[15px] text-ink-secondary transition-colors hover:text-primary"

  return (
    <header className="sticky top-0 z-50 border-b border-line bg-white/90 backdrop-blur-[10px]">
      <div className={`${CONTAINER} flex h-[68px] items-center gap-6`}>
        <a
          href={`#${ANCHORS.download}`}
          className="flex shrink-0 items-center gap-2.5 text-xl font-extrabold text-ink hover:no-underline"
        >
          {/* <span
            aria-hidden="true"
            className="grid h-8 w-8 place-items-center rounded-[9px] bg-primary-gradient text-[17px] font-extrabold text-white"
          >
            e
          </span> */}
          <span aria-hidden="true" className="w-[36px] h-[36px]">
            <img className="w-full " src={LogoPng} alt="" />
          </span>

          <span>henghengmall</span>
        </a>

        <div className="ml-auto flex items-center gap-5">
          <nav
            aria-label={t("official_nav_aria")}
            className="hidden items-center gap-5 lg:flex"
          >
            {navItems.map((item) => (
              <a key={item.id} href={`#${item.id}`} className={linkClass}>
                {item.label}
              </a>
            ))}
          </nav>

          <a
            href={DOWNLOAD_PAGE_URL}
            className="hidden shrink-0 rounded-full bg-[#01B0FE] px-[18px] py-[9px] text-sm font-semibold text-white transition hover:bg-[#01B0FE]/60 lg:inline-flex"
          >
            {t("official_cta_download")}
          </a>

          <LangSelect />

          <button
            type="button"
            aria-expanded={open}
            aria-label={
              open ? t("official_menu_close") : t("official_menu_open")
            }
            onClick={() => setOpen((prev) => !prev)}
            className="flex h-[42px] w-[42px] flex-col items-center justify-center gap-[5px] rounded-[10px] border border-line bg-white lg:hidden"
          >
            <span className="block h-0.5 w-[18px] bg-ink" />
            <span className="block h-0.5 w-[18px] bg-ink" />
            <span className="block h-0.5 w-[18px] bg-ink" />
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-line bg-white px-5 pb-4 lg:hidden">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              onClick={() => setOpen(false)}
              className={`block border-b border-line py-3 ${linkClass}`}
            >
              {item.label}
            </a>
          ))}
          <a
            href={DOWNLOAD_PAGE_URL}
            className="mt-3 inline-flex rounded-full bg-primary px-[18px] py-[9px] text-sm font-semibold text-white"
          >
            {t("official_cta_download")}
          </a>
        </nav>
      )}
    </header>
  )
}
